import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router';

import styled from '@emotion/styled';

import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';
import PageLayout from '../../../components/Layout/PageLayout';
import Page from '../../../components/Page/Page';
import { USER_MANAGEMENT } from '../../../routes/routeConstants';
import BusinessBioArea from './BusinessBioArea';
import BusinessDetails from './BusinessDetails';
import DirectorInformation from './DirectorInformation';
import LogisticDetails from './LogisticDetails';
import RatingTripLog from './RatingTripLog';
import VehicleVolumeType from './VehicleVolumeType';

const UserManagementBusinessProfile = () => {
  const [pathArr, setPathArr] = useState<Record<string, string>[]>([]);
  const { pathname } = useLocation();
  const { jsonData } = useParams();

  const objectFyData = jsonData
    ? JSON.parse(decodeURIComponent(jsonData ?? ''))
    : null;

  useEffect(() => {
    setPathArr(() => [
      {
        name: `User Management`,
        link: `/${USER_MANAGEMENT}`,
      },

      {
        name: `${objectFyData?.companyName ?? 'Cala Foods'} - Driver List`,
        link: pathname,
      },
    ]);
    // eslint-disable-next-line
  }, []);

  return (
    <Page title='Logirate | Business Profile'>
      <PageLayout>
        <BreadCrumbs pathData={pathArr as any} />
        <Container>
          <BusinessBioArea />
          <BusinessDetails />
          <LogisticDetails />
          <DirectorInformation />
          <Row>
            <RatingTripLog />
            <VehicleVolumeType />
          </Row>
        </Container>
      </PageLayout>
    </Page>
  );
};

export default UserManagementBusinessProfile;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
`;
